module.exports = __webpack_public_path__ + "static/img/exercise.113f058.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors/exercise.png
// module id = KnEm
// module chunks = 7